var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Widget, WidgetHeader, WidgetBody, WidgetFooter, WidgetTitle, WidgetDescription, WidgetButton } from "../";
import { InboxSection, InboxResults } from "../";

import "./InboxWidget.scss";

var InboxWidget = (_temp2 = _class = function (_Component) {
    _inherits(InboxWidget, _Component);

    function InboxWidget() {
        var _temp, _this, _ret;

        _classCallCheck(this, InboxWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getSize = function () {
            var widgetSize = _this.props.widgetSize;


            if (!widgetSize) {
                return {};
            }

            var grid = widgetSize.split(":");

            return {
                cols: parseInt(grid[0]),
                rows: parseInt(grid[1])
            };
        }, _this.getModuleSize = function () {
            var _this$getSize = _this.getSize(),
                cols = _this$getSize.cols,
                rows = _this$getSize.rows;

            if (cols <= 2) {
                return "small";
            }
        }, _this.getData = function () {
            var _this$props = _this.props,
                data = _this$props.data,
                url = _this$props.url,
                urlPattern = _this$props.urlPattern;

            var moduleSize = _this.getModuleSize();

            var results = data.results || data.models || [];
            var count = data.count || results.length || undefined;
            var rows = data.rows || results.length;

            var values = {
                rows: rows,
                count: count || rows
            };

            var _this$props2 = _this.props,
                title = _this$props2.title,
                description = _this$props2.description,
                button = _this$props2.button;


            description = description.replace("{rows}", rows);
            description = description.replace("{count}", count);

            var buttonLabel = button;
            var buttonUrl = url || undefined;

            var widgetData = {
                urlPattern: urlPattern,
                results: results
            };

            return {
                data: widgetData,
                title: title,
                description: description,
                buttonLabel: buttonLabel,
                buttonUrl: buttonUrl,
                moduleSize: moduleSize
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    InboxWidget.prototype.render = function render() {
        var _getData = this.getData(),
            data = _getData.data,
            moduleSize = _getData.moduleSize,
            title = _getData.title,
            description = _getData.description,
            buttonLabel = _getData.buttonLabel,
            buttonUrl = _getData.buttonUrl;

        return React.createElement(
            Widget,
            this.props,
            React.createElement(
                WidgetHeader,
                null,
                React.createElement(WidgetTitle, { title: title }),
                React.createElement(WidgetDescription, { description: description })
            ),
            React.createElement(
                WidgetBody,
                null,
                React.createElement(InboxResults, _extends({}, data, { moduleSize: moduleSize }))
            ),
            React.createElement(
                WidgetFooter,
                null,
                React.createElement(WidgetButton, { label: buttonLabel, url: buttonUrl })
            )
        );
    };

    return InboxWidget;
}(Component), _class.defaultProps = {
    expanded: true,
    widgetId: "inbox",
    widgetType: "inbox",
    widgetSize: "1:1",

    title: "Inbox",
    description: "{rows} of {count} messages",

    button: "Go to Inbox",
    url: "/inbox",
    urlPattern: "/inbox/:uniqueId",
    data: {
        results: []
    }
}, _temp2);


export default InboxWidget;